import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import CategoriesService from '../services/API/CategoriesService';
import { useParams } from 'react-router-dom';

const Main = () => {
         const [category, setCategory] = useState([]);
             const [isLoading, setIsLoading] = useState(true);
             const { id } = useParams();

         const fetchCategoryData = async () => {
            try {
              const res = await CategoriesService.getCategoryById(id);
              setCategory(res.data);
            } catch (error) {
              setIsLoading(false);
              console.error("Error fetching product data:", error);
            }
          };
          useEffect(() => {
            fetchCategoryData(id);
          }, []);
          console.log(category);
          
    return (
        <>
            <div className='category-sec-bg-banner'>
                <Container >
                    <div className='category-sec-text-div'>
                        <h1 className='category-sec-text'>{category.name}</h1>
                        <div className='category-sec-btn-div'>
                            {/* <button className='category-sec-btn'>14k {category.name}</button> */}
                            {/* <button className='category-sec-btn'>10k {category.name}</button> */}
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}

export default Main